import { getApiErrorMessage } from '@/utils/api/get-api-error-message'
import { toast } from '@/features/toast/toast'

const BOARD_ERROR_COPY: Record<string, string> = {
    BOARD_LIMIT_REACHED: 'Board limit reached — archive or delete boards to make room.',
    BOARD_PUBLISHING_REQUIRES_PAID: 'Publishing boards needs an active paid subscription.',
}

/**
 * Turns the board lifecycle error codes into actionable toasts. Returns whether the error was
 * one of them, so callers can keep their own handling for everything else.
 */
export const toastBoardLifecycleError = (error: unknown) => {
    const copy = BOARD_ERROR_COPY[getApiErrorMessage(error, '')]
    if (!copy) return false

    toast.error(copy)
    return true
}

/**
 * Mutation-level error handler: the lifecycle codes get their actionable copy, everything else a
 * generic failure toast — callers swallow the rejection, so this is the only user feedback.
 */
export const toastBoardMutationError = (error: unknown) => {
    if (toastBoardLifecycleError(error)) return
    toast.error(getApiErrorMessage(error, 'Something went wrong updating your boards.'))
}
